"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _emotion = require("../../utils/emotion");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _FocusBox = _interopRequireDefault(require("../FocusBox"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "className", "variant", "padding", "fullWidth", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Button = function Button(props) {
  var children = props.children,
    className = props.className,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'text' : _props$variant,
    padding = props.padding,
    fullWidth = props.fullWidth,
    disabled = props.disabled,
    rest = _objectWithoutProperties(props, _excluded);
  var pad = (0, _react.useMemo)(function () {
    if (!padding) {
      return undefined;
    }
    if (typeof padding === 'number') {
      return [padding];
    }
    return padding;
  }, [padding]);
  var rootClass = (0, _useCss["default"])(function (theme) {
    return _objectSpread(_objectSpread({
      all: 'unset',
      cursor: 'pointer',
      transitionDuration: '200ms',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: 1,
      whiteSpace: 'nowrap',
      width: fullWidth ? '100%' : undefined,
      color: theme.palette.accent.primary.color,
      padding: !pad ? undefined : theme.size.apply(theme, _toConsumableArray(pad)),
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      opacity: disabled ? 0.25 : 1
    }, theme.text()), {}, {
      '&:hover': {
        cursor: disabled ? 'default' : undefined,
        backgroundColor: disabled ? undefined : theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.low, 0.2),
        color: disabled ? undefined : theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.high)
      }
    });
  });
  var filledClass = (0, _useCss["default"])(function (theme) {
    return {
      backgroundColor: theme.palette.accent.primary.color,
      color: theme.palette.accent.primary.contrast.low,
      '&:hover': {
        color: theme.palette.accent.primary.contrast.low,
        backgroundColor: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.high, 0.75)
      }
    };
  });
  var classNames = (0, _emotion.cx)(rootClass, variant === 'filled' && filledClass, className);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusBox["default"], {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread({}, rest), {}, {
      disabled: disabled,
      className: classNames,
      children: children
    }))
  });
};
var _default = Button;
exports["default"] = _default;